import { render, staticRenderFns } from "./AsterCampaigns.vue?vue&type=template&id=52d0ed52&"
import script from "./AsterCampaigns.vue?vue&type=script&lang=js&"
export * from "./AsterCampaigns.vue?vue&type=script&lang=js&"
import style0 from "./AsterCampaigns.vue?vue&type=style&index=0&id=52d0ed52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports